import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Markup from '../markup';
import Burger from './Global/Burger';
import withBuilder from '../builder/hooks/withBuilder';
import BuilderContext from '../builder/hooks/context';
import { trackGoToAccount, trackGoToCart, trackProductSelection, trackReturnToStart } from '../utils/Analytics';
import { useTimeTracking } from '../utils/TimeTrackingContext';
import { models } from '../const/models';

const StartPage = ({ setManifest }) => {
  const [activeManifest, setActiveManifest] = useState(0);
  const [cartCount, setCartCount] = useState(null);
  const [previousCartCount, setPreviousCartCount] = useState("0");
  const history = useHistory();
  const { builder } = useContext(BuilderContext);
  const { logTimeSpent } = useTimeTracking();

  const moveToBuilder = () => {
    setManifest(models[activeManifest].manifest);
    trackProductSelection(models[activeManifest].product);
    history.push('/design');
  }

  const onStartPageClick = () => {
    if(window['builderOnLogoClick']) window['builderOnLogoClick']();
    trackReturnToStart('builder');
  }

  const onCartClick = () => {
    window['builderOnCart'] && window['builderOnCart']();
    trackGoToCart('icon');
    logTimeSpent();
  }

  const onUserAccountClick = () => {
    window['builderOnUserAccount'] && window['builderOnUserAccount']();
    trackGoToAccount();
    logTimeSpent();
  }

  const updateCartCount = async () => {
    const cartItemsCount = window['cartItemsCount'] && await window['cartItemsCount']();
    
    if (cartItemsCount === "0" && localStorage.getItem('previousCartCount')) {
      setCartCount(localStorage.getItem('previousCartCount'));
    } else {
      setCartCount(cartItemsCount);
    }
    
    setPreviousCartCount(cartItemsCount);
    localStorage.setItem('previousCartCount', cartItemsCount);
  }

  useEffect(() => {
    const savedCartCount = localStorage.getItem('previousCartCount');
    if (savedCartCount) {
      setPreviousCartCount(savedCartCount);
    }

    updateCartCount();
  }, [builder.cnCart]);

  // Listen for cart:updated events dispatched by useExporter after add-to-cart
  useEffect(() => {
    const handleCartUpdate = () => updateCartCount();
    window.addEventListener('cart:updated', handleCartUpdate);
    return () => window.removeEventListener('cart:updated', handleCartUpdate);
  }, []);


  return (
    <Markup.BaseLayout.StartPageContainer>
      <Markup.BaseLayout.Header>
        <Markup.Global.Logo onClick={onStartPageClick} themeColor={models[activeManifest].start_color}/>
        <Burger/>
        <Markup.BaseLayout.HeaderIconContainer>
          <Markup.Global.Link.LinkUserIcon onClick={onUserAccountClick} invert={true} themeColor={models[activeManifest].start_color}/>
          <Markup.Global.Link.LinkCartIcon onClick={onCartClick} invert={true} themeColor={models[activeManifest].start_color} count={cartCount !== null ? cartCount : previousCartCount}/>
        </Markup.BaseLayout.HeaderIconContainer>
      </Markup.BaseLayout.Header>

      <Markup.StartPage.Container>
        <Markup.StartPage.SelectContainer>
          {models.map((item, i) => (
            <Markup.StartPage.ModelItem
              key={item.preview}
              image={item.preview}
              active={i === activeManifest}
              onClick={() => setActiveManifest(i)}
              themeColor={models[activeManifest].start_color}
            />
          ))}
        </Markup.StartPage.SelectContainer>

        <Markup.StartPage.TextContainer themeColor={models[activeManifest].start_color}>
          <h1>
            Design your own esports {models[activeManifest].product}
            <span>{models[activeManifest].price}</span>
          </h1>
          <p>{models[activeManifest].description}</p>
          <Markup.Global.Button.PrimaryButton onClick={moveToBuilder} medium>CREATE {models[activeManifest].product}</Markup.Global.Button.PrimaryButton>
        </Markup.StartPage.TextContainer>

        <Markup.StartPage.SplashScreen poster={models[activeManifest].poster} themeColor={models[activeManifest].start_color} />
      </Markup.StartPage.Container>

    </Markup.BaseLayout.StartPageContainer>
  );
}

export default React.memo(withBuilder(StartPage));
